module.exports = __webpack_public_path__ + "img/pd-img-body7.c9de1e85.png";